module.exports = __webpack_public_path__ + "static/media/video.bedb1151.svg";